
import auth from "@/router/middlewares/auth"
import MainView from "@/components/layout/main-view"
import AccountSubuser from "@/components/account/account-subuser"
 import AccountDetails from "@/components/account/account-details"
 import AccountTask from "@/components/account/account-task"
import  LumaAccountUser from "@/components/account/details_account/luma-account-user"

export default [
    {
        path:'/account',
        name:'account-view',
        component:MainView,
        meta:{
            middleware:auth,
            "package":'account',
            "key":'account'
        }

    },
    {
      path:'/account/subuser',
      name:'account-subuser',
      component:AccountSubuser,
      meta:{
        middleware:auth,
        "package":'account',
        "key":'account'
      }

    },

    {
        path:'/account/user/:username',
        name:'user-details',
        component:LumaAccountUser,
        meta:{
            middleware:auth,
            "package":'account',
            "key":'account'
        }

    },

    {
        path:'/account/details',
        name:'account-details',
        component:AccountDetails,
        meta:{
            middleware:auth,
            "package":'account',
            "key":'account'
        }

    },

    {
        path:'/account/task',
        name:'account-task',
        component:AccountTask,
        meta:{
            middleware:auth,
            "package":'account',
            "key":'account'
        }

    }
]



// WEBPACK FOOTER //
// ./src/router/routes/account/index.js